import { version as v } from '../package.json';
import { OSS } from './core';
import * as utils from './utils';

export * from './utils';

export const version = v;

export { OSS };
export default {
  OSS,
  version,
  ...utils,
};
